import { createContext } from 'react'

export type AppConfigContextType = {
  environment: 'development' | 'production' | 'test'
}

const AppConfigContext = createContext<AppConfigContextType>({
  // Default to production environment just in case, but this will always be overridden by the provider.
  environment: 'production',
})

export default AppConfigContext
